module.exports = __webpack_public_path__ + "static/media/diaceutics-plc.b9e5036f.png";